import React from 'react';
import logo from "../../../img/fantasygm_logo.png";
import { Height, Opacity } from '@mui/icons-material';
import { UtilidadeService } from '../../services/api/utilidades/UtilidadesService';

// Tipagem das props para o componente, garantindo escalabilidade
interface MaintenanceProps {
  title?: string;
  message?: string;
  estimatedTime?: string;
}

const Maintenance: React.FC<MaintenanceProps> = ({
  title = "Site em Manutenção",
  message = "Estamos atualizando nosso sistema para oferecer uma melhor experiência. Voltaremos em breve!",
  estimatedTime
}) => {
  // Estilização inline simples (pode ser substituída por CSS Modules, Styled Components, etc.)
  const styles = {
    container: {
      display: 'flex',
      flexDirection: 'column' as const,
      alignItems: 'center',
      justifyContent: 'center',
      height: '100vh',
      textAlign: 'center' as const,
      backgroundColor: '#f4f4f9',
      padding: '20px',
      color: '#333',
      fontFamily: 'Arial, sans-serif',
    },
    icon: {
      fontSize: '64px',
      marginBottom: '20px',
    },
    title: {
      fontSize: '32px',
      marginBottom: '10px',
      color: '#2c3e50',
    },
    message: {
      fontSize: '18px',
      maxWidth: '500px',
      lineHeight: '1.5',
      marginBottom: '20px',
    },
    time: {
      fontWeight: 'bold',
      color: '#c27532',
    },
    logo: {
      height: '100%',
      display: 'flex',
      flexDirection: 'column' as const,
      alignItems: 'center',
      justifyContent: 'center',
      backgroundImage:
        `url(${logo}) `,
      backgroundRepeat: "no-repeat",      
      backgroundPosition: 'top',
      backgroundSize: UtilidadeService.isMobile() ? "200px" : "250px",
      //opacity: "0.9"

    }
  };

  return (
    <div style={styles.container}>
      <div style={styles.logo}>
        <div style={styles.icon}>🛠️</div>
        <h1 style={styles.title}>{title}</h1>
        <p style={styles.message}>{message}</p>
        {estimatedTime && (
          <p style={styles.time}>Previsão de retorno: {estimatedTime}</p>
        )}
      </div>
    </div>
  );
};

export default Maintenance;